<template>
  <div id="AuthDecider" class = "modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Acceder</p>
    </header>

    <section class="modal-card-body auth-decider-container">
      <div class = "part">
        <h3>¿Nuevo Usuario?</h3>
        <span class="material-icons md-48 icon">person_add</span>
        <p>Crea una cuenta y empieza a crear tus proyectos</p>
        <button class = "btn btn-bg-colored" v-on:click = "showRegister">Registrarse</button>
      </div>

      <div class = "part">
        <h3>Ya registrado</h3>
        <span class="material-icons md-48 icon">person</span>
        <p>Si ya tienes una cuenta haz click para acceder</p>
        <button class = "btn btn-bg-colored" v-on:click = "showLogin">Entrar (Login)</button>
      </div>
    </section>

    <!--
    <footer v-if="isModal" class="modal-card-foot">
      <button class = "btn" type="button" @click="close()">Cerrar</button>
    </footer>
    -->
  </div>
</template>

<script>
export default {
  name: 'AuthDecider',
  props: {
    isModal: false
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    showRegister: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingRegister': true})
      this.close()
    },
    showLogin: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingLogin': true})
      this.close()
    },
    close: function () {
      // this.$parent.close()
      this.$store.commit('setEditorConfigProperty', {'isShowingAuthDecider': false})
    }
  }
}

</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

h3 {
  font-weight: 700;
}

.auth-decider-container {
  display: flex;

  .part {
    padding: 0px 10px;
    max-width: 80%;
    text-align: center;
  }

  .icon {
    font-size: 50px;
    margin: 20px auto;
    width: 100%;
    text-align: center;
    background: #f0f0f0;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid @accentColor;;
  }

  button {
    margin: 22px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/AuthDecider.vue